import { getAmityCommunity } from "@amityco/ui-kit-open-source";
import { useEffect } from "react";

export default function GetCommunity({ communityId, onReady }) {
  const { community, joinCommunity } = getAmityCommunity(communityId);

  useEffect(() => {
    if (!community?.communityId) {
      return;
    }

    if (!community.isJoined) {
      joinCommunity().catch(console.error);
    }

    if (onReady) {
      onReady(community);
    }
  }, [community, joinCommunity, onReady]);

  return null;
}
